import {
  EFieldsName,
  IDataPreference,
  IFiltrosFluxoDeCaixa
} from "@/features/financas/views/Indicadores/@types/type";
import { AbstractSaveToApi } from "../../Preferencias/types";
import FluxoDeCaixaStrategy from "./FluxoDeCaixaStrategy";

export default class SaveFluxoDeCaixaToApi extends AbstractSaveToApi<IFiltrosFluxoDeCaixa> {
  buildPreference(filtro: IFiltrosFluxoDeCaixa): IDataPreference<unknown>[] {
    const filters = filtro.panelFluxoFilter ? filtro.panelFluxoFilter : filtro;
    const preferencia = new FluxoDeCaixaStrategy();

    return [
      preferencia.createCompanies(filters.contas as string[]),
      preferencia.createPlanoOrcamentario(
        filters.PlanosOrcamentarios as string[]
      ),
      preferencia.createStatus(filters.Status as number),
      preferencia.createCheckbox(
        EFieldsName.fluxoAPartirUltimoDiaConciliado,
        filters.APartirUltimoDiaConciliado as boolean
      ),
      preferencia.createCheckbox(
        EFieldsName.fluxoAExibirParcelasNaoAprovadas,
        filters.ExibirParcelasNaoAprovadas as boolean
      ),
      preferencia.createCheckbox(
        EFieldsName.fluxoAdicionarUmDiaNoVencimentoDeBoletosAReceber,
        filters.AdicionarUmDiaNoVencimentoDeBoletosAReceber as boolean
      ),
      preferencia.createCheckbox(
        EFieldsName.fluxoOcultarDinheiroDeCaixasAbertos,
        filters.OcultarDinheiroDeCaixasAbertos as boolean
      ),
      preferencia.createCheckbox(
        EFieldsName.fluxoOcultarTitulosVencidos,
        filters.OcultarTitulosVencidos as boolean
      ),
      preferencia.createCheckbox(
        EFieldsName.fluxoOcultarTransferencias,
        filters.OcultarTransferencias as boolean
      ),
      preferencia.createCheckbox(
        EFieldsName.fluxoValoresNosDiasOriginais,
        filters.ValoresNosDiasOriginais as boolean
      )
    ];
  }
}
